interface LoadingIndicatorProps {
  message?: string;
  fullscreen?: boolean;
}

export function LoadingIndicator({
  message = 'Loading...',
  fullscreen = false,
}: LoadingIndicatorProps) {
  if (fullscreen) {
    return (
      <div className="absolute inset-0 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm flex flex-col items-center justify-center z-10">
        <div className="animate-spin h-8 w-8 border-4 border-gray-200 dark:border-gray-300 border-t-[#E34290] rounded-full"></div>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{message}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className="animate-spin h-8 w-8 border-4 border-gray-200 dark:border-gray-300 border-t-[#E34290] rounded-full"></div>
      <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{message}</p>
    </div>
  );
}
